
export default $(()=>{

    let $featuredSlider = $('section.featured');
    let carouselOptions = {
        slidesToShow: 1,
        speed: 1000,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
    };

    $featuredSlider.find('.slider').slick(carouselOptions);
});